import { createGetEndpoint } from '@sonar-software/sonar-http';

export type AgentTool = {
	name: string;
};

export type AgentToolsResponse = {
	tools: Array<AgentTool>
};

export const getAgentTools = createGetEndpoint<void, AgentToolsResponse>(
	'/api/v3/agent/tools'
);
